/**
 * Route for `igaming-sim`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingSimPage } from "../features/igaming-sim/IgamingSimPage";

export const igamingSimRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-sim",
	component: IgamingSimPage,
});

export default igamingSimRoute;
